import { render, staticRenderFns } from "./WatsonIntent.vue?vue&type=template&id=c1f6024a&scoped=true&"
import script from "./WatsonIntent.vue?vue&type=script&lang=js&"
export * from "./WatsonIntent.vue?vue&type=script&lang=js&"
import style0 from "./WatsonIntent.vue?vue&type=style&index=0&id=c1f6024a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f6024a",
  null
  
)

export default component.exports